import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";
import {TaskModel} from "../../models/task.model";

export class taskEtaByStatusCtrl implements IController {

  task: TaskModel;
  timeZoneId: string;
  configZoneId: string;

  private warningStatuses: any;
  private timeZoneOffsetDiff: any;

  /* @ngInject */
  constructor(private splitService: SplitService) {
  }

  $onInit() {
    this.warningStatuses = {
      CourierArrived: true,
      CourierDeparted: true
    }
  }

  $onChanges(changes) {
    if (changes.configZoneId && !changes.configZoneId.isFirstChange()) {
      this.checkTimeZoneOffsetDiff();
    }
    if (changes.timeZoneId && !changes.timeZoneId.isFirstChange()) {
      this.checkTimeZoneOffsetDiff();
    }
  };

  ////////////////////////////////////////////////////////////////////////

  checkTimeZoneOffsetDiff() {
    this.timeZoneOffsetDiff = this.splitService.getTimeZoneOffsetDiff(this.timeZoneId, _.get(this.task, 'analysis.eta'));
    return this.timeZoneOffsetDiff !== 0;
  }

}

angular
  .module('bringoz.admin.tasks')
  .component('taskEtaByStatus', {
    bindings: {
      task: '<',
      timeZoneId: '<',
      configZoneId: '<?'
    },
    template: require('./task-eta-by-status.html').default,
    controller: taskEtaByStatusCtrl
  });
